export default {
  SET_DISTRIBUICAO_TABLE_ITEMS(state, payload) {
    state.distribuicaoTableItems = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_INVOICES(state, payload) {
    state.invoices = payload;
  },
  SET_MARCAS(state, payload) {
    const formattedPayload = payload.map((item) => ({
      marca: item.marca,
      valorTotal: item.valorTotal.trim(),
    }));

    state.marcas = state.marcas.map((marcaState) => {
      const matchingMarca = formattedPayload.find((item) => item.marca === marcaState.title);

      return {
        ...marcaState,
        value: matchingMarca ? matchingMarca.valorTotal : marcaState.value,
      };
    });
  },
};
